/**
* @prop --spacing: THe padding around the indicator
* @prop --duration: Animation duration in ms
* @prop --ease: Animation ease
* @prop --size: Width or height in %
*/
:host {
    width: 100%;
    height: 100%;

    .bar-component {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        display: flex;

        .bar-container {
            display: flex;
            align-items: center;
            padding: var(--spacing);

            .bar-indicator {
                width: 100%;
                height: 100%;
                transition-duration: var(--duration);
                transition-timing-function: var(--ease);
            }
        }

        &.bar-horizontal {
            height: auto;
            flex-direction: column;

            .bar-container {
                height: var(--bar);
                .bar-indicator {
                    width: var(--size);
                    transition-property: width;
                }
            }
        }

        &.bar-vertical {
            height: 100%;
            width: auto;

            .bar-container {

                align-items: end;
                .bar-indicator {
                    height: var(--size);
                    width: var(--bar);
                    transition-property: height;
                }
            }
        }
    }

    [part='background'] {
        border-style: solid;
        border-width:  0;
        box-sizing: border-box;
        overflow: clip;
        [part='indicator'] {
            border-style: solid;
            border-width:  0;
            box-sizing: border-box;
        }

    }
}

